module.exports = __webpack_public_path__ + "img/title-en.1e66207a.png";